import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function Filter({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#clip0_2985_80597)">
        <path
          d="M8.50008 3.02795H7.72217C7.30795 3.02795 6.97217 3.36374 6.97217 3.77795C6.97217 4.19217 7.30795 4.52795 7.72217 4.52795H8.80219C8.6108 4.0653 8.50371 3.55891 8.50008 3.02795Z"
          fill="currentColor"
        />
        <path
          d="M10.6945 6.57026C10.2328 6.33631 9.82255 6.01544 9.48538 5.62916C9.30839 5.76636 9.19446 5.98102 9.19446 6.22229V7.25012H1.5C1.08579 7.25012 0.75 7.58591 0.75 8.00012C0.75 8.41434 1.08579 8.75012 1.5 8.75012H9.19446V9.77785C9.19446 10.1921 9.53024 10.5278 9.94446 10.5278C10.3587 10.5278 10.6945 10.1921 10.6945 9.77785V6.57026Z"
          fill="currentColor"
        />
        <path
          d="M5.80554 2.00012C5.80554 1.58591 5.46976 1.25012 5.05554 1.25012C4.64133 1.25012 4.30554 1.58591 4.30554 2.00012V3.02795H1.5C1.08579 3.02795 0.75 3.36374 0.75 3.77795C0.75 4.19217 1.08579 4.52795 1.5 4.52795H4.30554V5.55568C4.30554 5.96989 4.64133 6.30568 5.05554 6.30568C5.46976 6.30568 5.80554 5.96989 5.80554 5.55568V3.78248L5.80556 3.77795L5.80554 3.77343V2.00012Z"
          fill="currentColor"
        />
        <path
          d="M12.6111 7.25012C12.1969 7.25012 11.8611 7.58591 11.8611 8.00012C11.8611 8.41434 12.1969 8.75012 12.6111 8.75012H13.5C13.9142 8.75012 14.25 8.41434 14.25 8.00012C14.25 7.58591 13.9142 7.25012 13.5 7.25012H12.6111Z"
          fill="currentColor"
        />
        <path
          d="M6.97217 12.2223C6.97217 11.8081 7.30795 11.4723 7.72217 11.4723H13.4999C13.9142 11.4723 14.2499 11.8081 14.2499 12.2223C14.2499 12.6365 13.9142 12.9723 13.4999 12.9723H7.72217C7.30795 12.9723 6.97217 12.6365 6.97217 12.2223Z"
          fill="currentColor"
        />
        <path
          d="M1.5 11.4723C1.08579 11.4723 0.75 11.8081 0.75 12.2223C0.75 12.6365 1.08579 12.9723 1.5 12.9723H4.30554V14C4.30554 14.4142 4.64133 14.75 5.05554 14.75C5.46976 14.75 5.80554 14.4142 5.80554 14V12.2268L5.80556 12.2223L5.80554 12.2178V10.4445C5.80554 10.0302 5.46976 9.69446 5.05554 9.69446C4.64133 9.69446 4.30554 10.0302 4.30554 10.4445V11.4723H1.5Z"
          fill="currentColor"
        />
        {/* <circle cx="12.5" cy="2.99988" r="2.5" fill="#F43F5E" /> */}
        {/* <circle
          cx="12.5"
          cy="2.99988"
          r="2"
          stroke="#18181B"
          stroke-opacity="0.12"
        /> */}
      </g>
      <defs>
        <clipPath id="clip0_2985_80597">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
